import { render, staticRenderFns } from "./UserHeader.vue?vue&type=template&id=2ba06e70&scoped=true&"
import script from "./UserHeader.vue?vue&type=script&lang=js&"
export * from "./UserHeader.vue?vue&type=script&lang=js&"
import style0 from "./UserHeader.vue?vue&type=style&index=0&id=2ba06e70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba06e70",
  null
  
)

export default component.exports